import { useRef } from "react";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type {
	DealDashboard,
	DealDashboardCondition
} from "~/models/DealDashboard";
import { convertQueryStringUrl } from "~/utils/DealSearchConditionUtils";

const paths = {
	index: "/vendors/homes"
};
type TIndex = (query: DealDashboardCondition) => SwrReturnType<DealDashboard>;
type ReturnType = {
	index: TIndex;
};

export const useHomes = (): ReturnType => {
	const cachedDataRef = useRef<DealDashboard | null>(null);

	const index: TIndex = (query: DealDashboardCondition) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<DealDashboard>(
			convertQueryStringUrl(paths.index, query)
		);

		if (data) {
			cachedDataRef.current = data;
		}

		return {
			data: data ?? cachedDataRef.current,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
